import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './assets/resource/js/axios/axiosInterceptor';
import MasonryWall from '@yeger/vue-masonry-wall';
import globalMethods from './assets/resource/js/global/global';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { Quasar } from 'quasar';

// window.Kakao.init("db24157d85ac0bc8fc7e9d12e073e6e8");

// 병원코드, 다국어, 병원No store
store.commit("getHost", location.hostname.split('.')[0]);

var hpCd = '';
if(location.hostname.split('.')[0].indexOf('anamrnd') > -1){
    hpCd = 'AA'
}else if(location.hostname.split('.')[0].indexOf('ansanrnd') > -1){
    hpCd = 'AS'
}else if(location.hostname.split('.')[0].indexOf('gurornd') > -1){
    hpCd = 'GR'
}

store.commit("getHpCd", hpCd);
store.commit("getLang", location.pathname.split('/')[1]);

var instNo = '';
if(location.hostname.split('.')[0].indexOf('anamrnd') > -1){
    instNo = 1
}else if(location.hostname.split('.')[0].indexOf('ansanrnd') > -1){
    instNo = 2
}else if(location.hostname.split('.')[0].indexOf('gurornd') > -1){
    instNo = 3
}
store.commit("getInstNo", instNo);

if(instNo == 1){
    document.title = '고려대학교 안암병원 국가지정 연구중심병원';
}else if(instNo == 2){
    document.title = '고려대학교 안산병원 국가지정 연구중심병원';
}else if(instNo == 3){
    document.title = '고려대학교 구로병원 국가지정 연구중심병원';
}else{
    document.title = '고려대학교 연구중심병원';
}

var app = createApp(App);
app.config.globalProperties.axios = axios;
app.config.globalProperties.menuList = [];
app.config.globalProperties.headerMenuList = [];

//'N'
var sync = 'N';

/**
 * 메뉴목록 조회하기
 */
axios.get('/menu.do', {
        params: {
            instNo: store.state.hpInfoStore.instNo,
            lang: store.state.hpInfoStore.lang
        }
    })
    .then((res) => {
        app.config.globalProperties.menuList = res.data;
        app.config.globalProperties.headerMenuList = res.data;
        sync = 'Y';
    })
    .catch(err => console.log(err));


var interval = setInterval(function(){
    if(sync == 'Y'){
        app.use(store).use(router).use(MasonryWall).use(globalMethods).use(Datepicker).use(Quasar).mount('#app');
        clearInterval(interval);
    }
},100);
